import { AccountType } from '@liquidbudget/common';
import {
  Banknote,
  BanknoteArrowDownIcon,
  BanknoteArrowUpIcon,
  CreditCard,
  LucideIcon,
  PiggyBank,
  TicketsPlane,
} from 'lucide-react';

/**
 * Mapping of account types to their corresponding Lucide icons.
 */
const iconMap: Record<AccountType, LucideIcon> = {
  [AccountType.CASH]: Banknote,
  [AccountType.CHECKING]: TicketsPlane,
  [AccountType.SAVINGS]: PiggyBank,
  [AccountType.CREDIT_CARD]: CreditCard,
  [AccountType.OFF_BUDGET_ASSET]: BanknoteArrowUpIcon,
  [AccountType.OFF_BUDGET_LIABILITY]: BanknoteArrowDownIcon,
};

/**
 * Returns the appropriate Lucide icon component for a given account type.
 * Defaults to Banknote icon if no type is provided.
 *
 * @param type - The AccountType to get an icon for
 * @returns A Lucide icon component
 */
export const getAccountTypeIcon = (type?: AccountType): LucideIcon => {
  return type ? iconMap[type] : Banknote;
};
